import { gql } from "@apollo/client"
import { VENDOR_DETAIL_FRAG } from "./vendor.fragments.gql"

export const ADD_UPDATE_VENDOR = gql`
  mutation AddUpdateVendor(
    $address: AddressInput!
    $dateOfBirth: Date
    $education: BaseUserEducationEnum
    $email: String
    $firstName: String!
    $gender: BaseUserGenderEnum
    $groups: [ID]
    $id: ID
    $kycDetail: KYCDetailInput
    $lastName: String!
    $number: String!
    $referenceId: String
    $username: String! # $routeIds: [ID]
  ) {
    addUpdateVendor(
      address: $address
      dateOfBirth: $dateOfBirth
      education: $education
      email: $email
      firstName: $firstName
      gender: $gender
      groups: $groups
      id: $id
      kycDetail: $kycDetail
      lastName: $lastName
      number: $number
      referenceId: $referenceId
      username: $username # routeIds: $routeIds
    ) {
      user {
        ...VendorDetailFrag
      }
    }
  }
  ${VENDOR_DETAIL_FRAG}
`

export const BULK_UPDATE_USERS = gql`
  mutation bulkUpdateVendors($userIds: [ID!]!, $status: String!) {
    bulkUpdateUsers(userIds: $userIds, status: $status) {
      users {
        id
        status
        statusObj @client {
          id
          intent
          name
        }
      }
    }
  }
`
